import { PhGlobe } from 'ember-phosphor-icons';
import { VStack } from 'tio-ui/components/layout';
import { t } from 'ember-intl';

<template>
  <VStack>
    <div class="flex justify-center items-center text-gray-700">
      <PhGlobe @size="24" @weight="thin" class="text-purple-900" />
      {{t "lpn.tile.tio_learning_partner_network"}}
    </div>
    <div class="flex flex-col justify-center items-center mt-6">
      <p class="">{{t "lpn.lpn_card_body" htmlSafe=true}}</p>
    </div>

  </VStack>
</template>
